define('models/Podio.Models.User',['require','underscore','lib/backbone/Backbone.PodioModel','lib/backbone/Backbone.Mixins.Transport.API','lib/Podio.Routes','lib/Podio.Config'],function(require) {

  var _ = require('underscore');
  var ModelPodioBase = require('lib/backbone/Backbone.PodioModel');

  var APITransport = require('lib/backbone/Backbone.Mixins.Transport.API');

  var routes = require('lib/Podio.Routes');
  var podioConfig = require('lib/Podio.Config');

  return ModelPodioBase.extend({

    setProperty : function(name, value) {
      var url = routes.user_property_path(name);
      var requestData;

      if (_.isObject(value)) {
        requestData = { 'hash': value };
        podioConfig.user.properties[name] = value;
      } else {
        // value _must_ be a boolean, otherwise use { key: value } as
        // the `value` argument when calling this method
        requestData = { 'value': value };
        podioConfig.user.properties[name] = { 'value': value };
      }

      return this.request('post', url, requestData);
    },

    removeProperty : function(name) {
      if (podioConfig.user.properties[name]) {
        delete podioConfig.user.properties[name];
      }
      var url = routes.user_property_path(name);
      return this.request('delete', url);
    },

    getProperty: function(name) {
      var val = podioConfig.user.properties[name];

      if (_.isDefined(val)) {
        if (Object.keys(val).length === 1 && _.isBoolean(val['value'])) {
          return val.value;
        } else {
          return val;
        }
      }

      return null;
    },

    setSegmentationPreference: function(industry, intendedUse) {
        var data = {'industry': industry, 'intended_use': intendedUse};
        return APITransport.request('put', '/user/segmentation', data)
    },

    setProfile: function(requestData) {
      return APITransport.request('put', '/user/profile/', requestData);
    },

    setProfileKey: function(key, value) {
      return APITransport.request('put', '/user/profile/{0}'.format(key), value);
    },

    getOnboardingSpace: function() {
      return this.request('get', routes.signup_onboarding_space_path());
    }

  });

});

